import React from "react";

import AvatarChooser from "./AvatarChooser";

function Avatar(props) {
  const { value, sendAvatarToDB } = props;

  // O alinhamento da imagem precisa mudar de acordo com
  // o tamanho da tela.
  const styles = { margin: "auto", alignSelf: "center" };
  return (
    <div style={styles}>
      <AvatarChooser
        id="avatar"
        alt="foto do usuário"
        value={value}
        onChange={(e) => {
          if (e && sendAvatarToDB) {
            sendAvatarToDB(e);
          }
        }}
      />
    </div>
  );
}

export default Avatar;
